import parse, {
  domToReact,
  type DOMNode,
  type Element,
} from 'html-react-parser';
import { Heading, Paragraph } from '@hungryroot/ramen';
import { ShowMore } from '../ShowMore/ShowMore';
import styles from './Instructions.module.css';

interface Props {
  cookTime: number;
  instructions: string;
  disclaimer?: string;
  className?: string;
  initialExpansion?: boolean;
}

const replaceParagraphTag = (domNode: DOMNode) => {
  if (domNode.type === 'tag') {
    const element = domNode as Element;
    if (element.name === 'p') {
      return (
        <Paragraph className={styles.section}>
          {domToReact(element.children as DOMNode[])}
        </Paragraph>
      );
    }
  }
};

export function Instructions(props: Props) {
  const {
    cookTime,
    instructions,
    disclaimer,
    className,
    initialExpansion = false,
  } = props;

  const parseOptions = {
    replace: replaceParagraphTag,
  };

  const getElementCount = (htmlString: string) => {
    const parsedElements = parse(htmlString, parseOptions);

    if (!Array.isArray(parsedElements)) return 1;
    return parsedElements.length;
  };

  const getFirstElement = (htmlString: string) => {
    const parsedElements = parse(htmlString, parseOptions);

    if (Array.isArray(parsedElements)) {
      return parsedElements[0];
    }

    return parsedElements;
  };

  const firstInstruction = getFirstElement(instructions);

  return (
    <div className={`${styles.instructions} ${className}`}>
      <Heading className={styles.heading} variant="H5">
        Instructions
      </Heading>
      <Paragraph className={styles['cook-time']}>
        Cook time: {cookTime} {cookTime === 1 ? 'minute' : 'minutes'}
      </Paragraph>
      {disclaimer && (
        <Paragraph className={styles.disclaimer}>{disclaimer}</Paragraph>
      )}
      {getElementCount(instructions) > 1 ? (
        <ShowMore
          buttonClassName={styles['show-more']}
          initialIsExpanded={initialExpansion}
          expandedContent={parse(instructions, parseOptions)}
          condensedContent={firstInstruction}
        />
      ) : (
        firstInstruction
      )}
    </div>
  );
}
